import { icon } from "@fortawesome/fontawesome-svg-core";
import { faFacebook, faInstagram, faTiktok, faYoutube } from "@fortawesome/free-brands-svg-icons";

export const imageData = ['pic1.jpeg','pic2.jpeg', 'pic3.jpeg', 'pic4.jpeg', 'pic5.jpeg','pic6.png','pic7.png', 'pic8.png', 'pic9.png', 'pic10.png'];

export const bgColors = ["#0d0404","#8f6106","#8f0666","#067a8f","#068f3b","#278cca","#004d8c"];

export const strategyData = [
    {
        icon: 'medical.svg',
        text: 'Access to affordable health care'
    },
    {
        icon: 'water-supply.svg',
        text: 'Sufficient uninterrupted supply of safe water'
    },
    {
        icon: 'road.svg',
        text: 'Opening of farm-to-market roads'
    },
    {
        icon: 'education.svg',
        text: 'Promotion of education'
    },
    {
        icon: 'energy.svg',
        text: 'Sufficient and uninterrupted energy supply preferably from our independently owned solar grid'
    },
    {
        icon: 'gender.svg',
        text: 'Promotion of gender balance'
    },
    {
        icon: 'employment.svg',
        text: 'Creation of job opportunities'
    },
    {
        icon: 'income.svg',
        text: 'Promotion of household income strengthening initiatives'
    },
    {
        icon: 'factory.svg',
        text: 'Food transformation and preservation'
    }
];

export const footerLinks = [
    { uri: "/", caption: "About MBECUDA"},
    { uri: "/blog", caption: "Events Blog"},
    { uri: "/village", caption: "Mbei village"},
    { uri: "/development", caption: "Development"},
    { uri: "/branches", caption: "Mbecuda Branches"}
];


export const socialLink = [
    { uri: "https://facebook.com/groups/374534424557231/", caption: "MBECUDA WORLD", icon: faFacebook},
    { uri: "https://www.facebook.com/profile.php?id=100063716155780", caption: "MBECUDA USA", icon: faFacebook},
    {uri: "https://www.instagram.com/mbecudaworld/", caption: "MBECUDA WORLD", icon: faInstagram},
    {uri: "https://www.tiktok.com/@mbecudaworld", caption: "MBECUDA WORLD", icon: faTiktok},
    {uri: "https://www.youtube.com/@mbecuda", caption: "MBECUDA WORLD", icon: faYoutube}
]